import { Controller } from "@hotwired/stimulus"

// 通用：表单内某个控件变化时立即提交整个表单（用于 on/off 开关，免去单独的"保存"按钮）
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
